import styled from '@emotion/styled'
import { Box } from '@material-ui/core'

const ListContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$align',
})<{ $align: 'left' | 'right' }>(({ theme, $align }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  width: 0,
  minWidth: '100%',
  overflowX: 'auto',
  justifyContent: 'flex-start',
  ...($align === 'right' && { '& > :first-of-type': { marginLeft: 'auto' } }),
  padding: theme.spacing(1, 1, 0.5),
  marginBottom: theme.spacing(0.5),
}))

export { ListContainer }
